export default __webpack_public_path__ + "static/media/CustomPics.41388bee.png";